import React, { useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton } from "@mui/material";

import { useTranslation } from "react-i18next";
import DataTable from "../common/DataTable";
import CustomModal from "../common/CustomModal";
import { Edit } from "@mui/icons-material";
import CustomMaster from "../common/CustomMaster";
const title = "Security Controls";

const CompanySetting = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [leadModal, setLeadModal] = useState(false);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

    const columns = useMemo(
        () => [
            { accessorKey: 'sn', header: 'SN', size: 100 },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <IconButton onClick={() => handleViewClick(row.original.sn)}>
                        <Edit />
                    </IconButton>
                ),
            },
        ],
        []
    );
    const data = [
        {
            sn: "1",
            date: "23/03/2024",
            company: "KG 2",
            mobile: "37263274",
            leadSource: "New",
            leadOwner: "new",
            status: "In progress",
            priority: "low",
            lossReason: "low quality",
            createdBy: "KG",
        },
        {
            sn: "2",
            date: "23/03/2024",
            company: "AG",
            mobile: "37263274",
            leadSource: "AG pvt",
            leadOwner: "AG Pvt",
            status: "In progress",
            priority: "low",
            lossReason: "Transportation delayed",
            createdBy: "AG",
        },
    ];
    const handleOpen = () => {
        setLeadModal(true);
    };
    const handleClose = () => {
        setLeadModal(false)
    }

    const handleViewClick = (id) => {
        navigate(`#`);
    };

    const defaultView = 'securitycontrols';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={data}
                    handleOpen={handleOpen}
                    buttonTitle="Create"
                />
                <CustomModal open={leadModal} handleClose={handleClose}>
                </CustomModal>
            </Box>
        </>
    );
    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default CompanySetting;
